import m from "../../geodata/es2015/chadHigh";
window.am4geodata_chadHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/chadHigh.js
// module id = null
// module chunks = 